const DEFAULT_SERVICE_KEY = 'DEFAULT';
const MAP = 'MAP';
const ROUTING = 'ROUTING';
const SEARCH = 'SEARCH';
const TRAFFIC_FLOW = 'TRAFFIC_FLOW';
const TRAFFIC_INCIDENTS = 'TRAFFIC_INCIDENTS';

export const SERVICE_TYPES = {
    'DEFAULT': DEFAULT_SERVICE_KEY,
    MAP,
    ROUTING,
    SEARCH,
    TRAFFIC_FLOW,
    TRAFFIC_INCIDENTS
};



// WEBPACK FOOTER //
// ./core/serviceTypes.js